// Реальная ширина файла картинки блюда — по папке, в которой он лежит
// (API отдаёт только URL). Старые фото: 200x/ и 600x/; новые (с ноября 2026):
// min/ — до 600px, max/ — до 1600px. По этим числам браузер в srcset сам
// выбирает файл под размер и плотность экрана.
export function imgWidth(url, fallback) {
    if (!url) return fallback
    if (url.includes('/products/200x/')) return 200
    if (url.includes('/products/600x/')) return 600
    if (url.includes('/products/min/')) return 600
    if (url.includes('/products/max/')) return 1600
    return fallback
}

export function dishSrcset(p) {
    return `${p.image_min} ${imgWidth(p.image_min, 200)}w, ${p.image_max} ${imgWidth(p.image_max, 600)}w`
}
